import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const NAV = [
  { label: "Producten", href: "#producten" },
  { label: "Hoe werkt het?", href: "#hoe-werkt-het" },
  { label: "Prijzen", href: "#prijzen" },
  { label: "FAQ", href: "#faq" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToForm = () => {
    setOpen(false);
    const el = document.getElementById("lead-form");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "jn-glass-strong" : "bg-transparent"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <a href="#top" data-testid="header-logo-link">
          <Logo size="text-xl md:text-2xl" />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm text-zinc-300 hover:text-white transition-colors font-body"
              data-testid={`nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={scrollToForm}
            className="hidden md:inline-flex jn-btn-primary px-5 py-2.5 rounded-full text-sm"
            data-testid="header-cta-offerte"
          >
            Offerte aanvragen
          </button>
          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2 text-white"
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          className="lg:hidden jn-glass-strong border-t border-white/10"
          data-testid="mobile-menu"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="text-zinc-200 font-body"
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </a>
            ))}
            <button
              onClick={scrollToForm}
              className="jn-btn-primary px-5 py-3 rounded-full text-sm w-full"
              data-testid="mobile-cta-offerte"
            >
              Offerte aanvragen
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
